import {UI} from "../../../../../stem-core/src/ui/UIBase";

import {BasePanelPage} from "../../../PanelPage";
import {Messages} from "../../../../Messages";
import {Router} from "../../../../../stem-core/src/ui/Router";
import {wrapInSpinner} from "../../../../../core/ui/LoadingSpinner.jsx";
import {apiDeletePaymentMethod} from "../../../../../client/state/PaymentMethodStore";
import {Flow} from "../../../flows/Flow.js";
import {Toast} from "../../../../ui/Toast.jsx";
import {BlinkButton} from "../../../../../core/ui/Button.jsx";
import {BackButton} from "../../../../../core/ui/LinkButton.jsx";
import {MessageElement} from "../../../../widget/ui/MessageElement.jsx";


export class UserDashboardRemoveCardPanel extends BasePanelPage {
    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            title: Messages.removeCard,
        };
    }

    @wrapInSpinner
    async removeCard() {
        await apiDeletePaymentMethod(Flow.dashboard.card.id);
        Router.back();
        Toast.showSuccess(Messages.cardRemoved);
    }

    render() {
        const {styleSheet} = this;
        const {card} = Flow.dashboard;

        return [
            <MessageElement message={Messages.removeCardEndingIn(card.getBrand(), card.getLastDigits())} />,
            <BlinkButton
                label={Messages.remove}
                className={styleSheet.actionButton}
                onClick={() => this.removeCard()}
            />,
            <BackButton label={Messages.cancel} />,
        ];
    }
}
